import React, {forwardRef} from 'react';
import ReactSlickCarousel, {Settings} from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export type ReactSlickCarouselType = ReactSlickCarousel;

export const SlickCarousel = forwardRef<ReactSlickCarouselType, Settings>(
  (props, ref) => {
    return <ReactSlickCarousel {...props} ref={ref} />;
  }
);
